'use client'

import type { FC } from 'react'
import styles from './LoaderWrapper.module.scss'
import { LoadingIndicator } from '@/tools/ui'

interface Props {
  loading: boolean
  children: React.ReactNode
}

export const LoaderWrapper: FC<Props> = ({ loading, children }) => (
  <>
    {loading ? (
      <section className={styles.container} data-testid="loader-wrapper">
        <LoadingIndicator size="l" />
      </section>
    ) : (
      children
    )}
  </>
)
